import { QUERY_PARAM_ORIGIN_URL } from '@/globals';

export default ({ app, route }) => {
    let originUrl = route.query[QUERY_PARAM_ORIGIN_URL];
    originUrl = originUrl == null ? null : originUrl;
    app.store.commit('setOriginUrl', originUrl);
};
